import { Tag, TagProps, Skeleton } from "@chakra-ui/react";
import { useIsIssueResolvedQuery } from "../hooks";

interface IssueStatusTagProps extends TagProps {
  issueId: string;
}

export default function IssueStatusTag({ issueId, ...rest }: IssueStatusTagProps) {
  const { data, isLoading } = useIsIssueResolvedQuery(issueId);

  if (isLoading) {
    return <Skeleton height="20px" width="60px" />;
  }

  const isResolved = data?.resolved ?? false;

  return (
    <Tag
      colorScheme={isResolved ? "green" : "red"}
      size="sm"
      {...rest}
    >
      {isResolved ? "Resolved" : "Unresolved"}
    </Tag>
  );
}
